import styled from 'styled-components'

export const PageTitle = styled.h1`
  font-size: 2em;
  text-transform: uppercase;
  font-weight: 500;
  border-bottom: 2px solid #ef4e45;
  padding: 12px;
`
